/* eslint-disable @typescript-eslint/no-unused-vars */
import { ChangeEvent, useEffect, useState } from 'react';
import { Alert, Avatar, Box, Button, Grid, LinearProgress, Paper, Snackbar, SnackbarCloseReason, TextField } from '@mui/material';
import { useNavigate, useParams } from 'react-router-dom';
import * as yup from 'yup';
import { VTextField, VForm, useVForm, IVFormErrors, VSwitch, AutoCompleteSubgrupoProdutos, VTextFieldNumber, VFieldMoney4, AutoCompletePatrimonio, VTextFieldData, AutoCompleteProduto2, VFieldMoney, AutoCompletePivotfazenda, AutoCompleteAtividades, AutoCompleteCultivo } from '../../../shared/forms';
import { FerramentasDeDetalhe } from '../../../shared/components';
import { LayoutBaseDePagina } from '../../../shared/layouts';
import { ProdutosService } from '../../../shared/services/api/estoque/produtos/ProdutosService';
import { AutoCompleteGrupoDeProdutos } from '../../../shared/forms/AutoCompleteGrupoDeProdutos';
import { AbastecimentoService, IGetAbas } from '../../../shared/services/api/estoque/Abastecimento/AbastecimentoService';
import SwipeableTextMobileStepper from '../os/SwipeableTextMobileStepper';
import { Environment } from '../../../shared/environment';

interface IFormData {
  idpatrimonio: string,
  idprod: string,
  dataoperacao: Date,
  idcultivo?: string | null;
  idpivot?: string | null;
  idatividade: string,
  horimetro: number,
  horimetronicial: number,
  quantidade: number,
  preco: number,
  total: number,
  operador: string,
  horastrabalhadas: number,
  litros: number,
  kmhr: string,
  quantidadeestoque: number,
}

interface IImage {
  imgPath: string;
  arquivo: File | undefined;
}

interface IArquivos {
  Path: string;
  arquivo: File | undefined;
}

const formValidationSchema: yup.ObjectSchema<Omit<IFormData, 'idoperacao' | 'totalabastecimento'>> = yup.object().shape({
  idpatrimonio: yup.string().required(),
  idprod: yup.string().required(),
  dataoperacao: yup.date()
    .required()
    .test('valid-date', 'Selecione uma data válida', function (value) {
      const currentDate = new Date();
      currentDate.setHours(0, 0, 0, 0);
      const minDate = new Date(currentDate);
      minDate.setDate(currentDate.getDate() - 6);
      if (!value) return false;
      return value >= minDate && value <= currentDate;
    }),
  idcultivo: yup.string().nullable().matches(/^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-5][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}$/, 'Deve ser um UUID válido'),
  idpivot: yup.string().nullable().matches(/^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-5][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}$/, 'Deve ser um UUID válido'),
  idatividade: yup.string().required(),
  horimetronicial: yup.number().optional().default(0),
  horimetro: yup.number().required('Horímetro Atual está incorreto!')
    .test('is-valid-horastrabalhadas', 'Algo de errado no preenchimento do campo Horímetro/KM Atual', function (value) {
      const { kmhr, horimetronicial } = this.parent;
      if (kmhr === 'km') {
        return value > horimetronicial;
      }
      return true;
    }),
  quantidade: yup.number().required('Quantidade inválida!')
    .test('is-valid-quantidade', 'Quantidade maior que o tanque / Quantidade menor que o Estoque', function (value) {
      const { quantidadeestoque, litros } = this.parent;
      if (quantidadeestoque != null && litros != null) {
        return value > 0 && value <= quantidadeestoque && value <= litros;
      }
      return false;
    }),
  preco: yup.number().required().moreThan(0),
  total: yup.number().required().moreThan(0),
  operador: yup.string().required(),
  horastrabalhadas: yup.number()
    .required('Horímetro Atual está incorreto!')
    .test('is-valid-horastrabalhadas', 'Algo de errado no preenchimento do campo Horímetro/KM Atual', function (value) {
      const { kmhr } = this.parent;
      if (kmhr === 'km') {
        return value < 10000;
      } else if (kmhr === 'horimetro') {
        return value > 0 && value <= 24;
      }
      return true;
    }),
  kmhr: yup.string().required().default(''),
  litros: yup.number().required().moreThan(0),
  quantidadeestoque: yup.number().required(),
});

export const DetalheDeAbastecimento: React.FC = () => {
  const { id = 'novo' } = useParams<'id'>();
  const navigate = useNavigate();
  const { formRef, save, saveAndClose, isSaveAndClose } = useVForm();
  const [isLoading, setIsLoading] = useState(false);
  const [descricao, setDescricao] = useState('');
  const [urlimge, setUrlimge] = useState<string | null>(null);
  const [image, setImage] = useState<string | null>(null);
  const [selectedImage, setSelectedImage] = useState<File | undefined>();
  const [horimetroinicial, sethorimetroinicial] = useState(0);
  const [idpatrimonios, setidpatrimonios] = useState('');
  const [totalvalor, settotalvalor] = useState(0);
  const [quantidadeestoque, setquantidadeestoque] = useState(0);
  const [litros, setlitros] = useState(0);
  const [kmhora, setkmhr] = useState('');
  const [presosaidaa, setprecosaida] = useState(0);
  const [images, setImages] = useState<IImage[]>([]);
  const [arquivos, setArquivos] = useState<IArquivos[]>([]);
  const [idprod, setidprod] = useState<string>();

  const [openmsg, setOpenmsg] = useState(false);
  const [msg, setMsg] = useState('');
  const [tms, setTms] = useState<'warning' | 'error' | 'info' | 'success'>('warning');

  const [openConfirm, setOpenConfirm] = useState(false);

  const handleCloseMsg = (
    event?: React.SyntheticEvent | Event,
    reason?: SnackbarCloseReason,
  ) => {
    if (reason === 'clickaway') {
      return;
    }
    setOpenmsg(false);
    if (tms === 'success') {
      navigate('/abastecimento');
    }
  };

  const handleDelete = () => {
    setOpenConfirm(true);
  };

  const handleConfirmDelete = () => {
    AbastecimentoService.deleteById(id)
      .then(result => {
        if (result instanceof Error) {
          setOpenConfirm(false);
          setTms('error');
          setMsg(result.message);
          setOpenmsg(true);
        } else {
          setOpenConfirm(false);
          setTms('success');
          setMsg('Registro apagado com sucesso!');
          setOpenmsg(true);
        }
      });
  };

  const imagesnovo = [{ imgPath: `${Environment.URL_IMGPATRIMONIO}semimagem.png`, arquivo: undefined }];
  const arquivonovo = [{ Path: `${Environment.URL_IMGPATRIMONIO}semimagem.pdf`, arquivo: undefined }];

  const handleCancelDelete = () => {
    setOpenConfirm(false);
  };

  useEffect(() => {
    if (id !== 'novo') {
      setIsLoading(true);
      AbastecimentoService.getById(id)
        .then((result) => {
          setIsLoading(false);
          if (result instanceof Error) {
            setTms('error');
            setMsg(result.message);
            setOpenmsg(true);
          } else {
            formRef.current?.setData(result);
            if (result.fotos === null || result.fotos.length === 0) {
              setImages(imagesnovo);
            } else {
              const imageList: IImage[] = [];
              result.fotos.forEach((item) => {
                imageList.push({ imgPath: Environment.URL_IMGPATRIMONIO + item.imgPath, arquivo: undefined });
              });
              setImages(imageList);
            }
            if (result.fotos === null || result.fotos.length === 0) {
              setArquivos(arquivonovo);
            } else {
              const filesList: IArquivos[] = [];
              result.fotos.forEach((item) => {
                filesList.push({ Path: item.imgPath, arquivo: undefined });
              });
              setArquivos(filesList);
            }
          }
        });
    }
  }, [id]);

  const handleSave = (dados: IFormData) => {
    const dadosAtualizados = { ...dados, horimetronicial: horimetroinicial, idpatrimonio: idpatrimonios, total: totalvalor, preco: presosaidaa, kmhr: kmhora, litros: litros, quantidadeestoque: quantidadeestoque, };
    formValidationSchema
      .validate(dadosAtualizados, { abortEarly: false })
      .then((result) => {
        setIsLoading(true);
        AbastecimentoService
          .updateById(id, result)
          .then((result) => {
            setIsLoading(false);
            if (result instanceof Error) {
              setTms('error');
              setMsg(result.message);
              setOpenmsg(true);
            } else {
              setTms('success');
              setMsg('Alteração concluída com sucesso!');
              setOpenmsg(true);
            }
          });

      })
      .catch((errors: yup.ValidationError) => {
        const validationErrors: IVFormErrors = {};
        errors.inner.forEach(error => {
          if (!error.path) return;
          validationErrors[error.path] = error.message;
        });
        formRef.current?.setErrors(validationErrors);
      });
  };
  const handleImageChange = (event: ChangeEvent<HTMLInputElement>) => {
    setSelectedImage(event.target.files?.[0]);
    const imagen = event.target.files?.[0];
    if (imagen) {
      const imageUrl = URL.createObjectURL(imagen);
      setImage(imageUrl);
    }
    if (id !== 'novo') {
      ProdutosService.updateByIdImg(id, imagen, urlimge)
        .then(result => {
          if (result instanceof Error) {
            setTms('error');
            setMsg(result.message);
            setOpenmsg(true);
          } else {
            setTms('success');
            setMsg('Imgaem alterada com sucesso!');
            setOpenmsg(true);
          }
        });
    }
  };
  const handlePrecoCompra = (valor: string | undefined) => {
    if (valor != null) {
      valor = valor.replace(/\D/g, '');
      valor = valor.replace(/(\d)(\d{4})$/, '$1.$2');
      valor = valor.replace(/(?=(\d{3})+(\D))\B/g, '');
      const data = formRef.current?.getData();
      const frete = data?.frete;
      const despesas = data?.precocusto;
      const tvalor = (Number(valor) + Number(frete) + Number(despesas));
      formRef.current?.setFieldValue('precosaida', tvalor);
      const percentual = data?.percentual;
      const tvalorVenda = (tvalor + ((tvalor / 100) * percentual));
      formRef.current?.setFieldValue('precovenda', tvalorVenda);
    }
  };
  const handleFrete = (valor: string | undefined) => {
    if (valor != null) {
      valor = valor.replace(/\D/g, '');
      valor = valor.replace(/(\d)(\d{4})$/, '$1.$2');
      valor = valor.replace(/(?=(\d{3})+(\D))\B/g, '');
      const data = formRef.current?.getData();
      const precocompra = data?.precocompra;
      const despesas = data?.precocusto;
      const tvalor = (Number(valor) + Number(precocompra) + Number(despesas));
      formRef.current?.setFieldValue('precosaida', tvalor);
      const percentual = data?.percentual;
      const tvalorVenda = (tvalor + ((tvalor / 100) * percentual));
      formRef.current?.setFieldValue('precovenda', tvalorVenda);
    }
  };
  const handleDespesa = (valor: string | undefined) => {
    if (valor != null) {
      valor = valor.replace(/\D/g, '');
      valor = valor.replace(/(\d)(\d{4})$/, '$1.$2');
      valor = valor.replace(/(?=(\d{3})+(\D))\B/g, '');
      const data = formRef.current?.getData();
      const precocompra = data?.precocompra;
      const frete = data?.frete;
      const tvalor = (Number(valor) + Number(precocompra) + Number(frete));
      formRef.current?.setFieldValue('precosaida', tvalor);
      const percentual = data?.percentual;
      const tvalorVenda = (tvalor + ((tvalor / 100) * percentual));
      formRef.current?.setFieldValue('precovenda', tvalorVenda);
    }
  };
  const handlePercentual = (valor: string | undefined) => {
    if (valor != null) {
      valor = valor.replace(/[^\d.]/g, '');
      const data = formRef.current?.getData();
      const precosaida = data?.precosaida;
      const tvalor = (((Number(precosaida) / 100) * Number(valor)) + Number(precosaida));
      formRef.current?.setFieldValue('precovenda', tvalor);
    }
  };

  const handleprecosaida = (psaida: number | undefined) => {
    if (psaida != null) {
      setprecosaida(psaida);
    }
  };

  const handlepreco = (valor: string | undefined) => {
    const preco = presosaidaa;
    const quantidadevalor = valor;
    if (preco && quantidadevalor) {
      const quantidadeNumerica = Number(quantidadevalor.replace(',', '.'));
      if (!isNaN(quantidadeNumerica)) {
        const total = Number(preco) * quantidadeNumerica;
        const totalArredondado = Math.round(total * 10000) / 10000;
        settotalvalor(totalArredondado);
      } else {
        setTms('error');
        setMsg('Quantidade inválida.');
        setOpenmsg(true);
      }
    } else {
      setTms('error');
      setMsg('campo de combustivel não selecionado corretamente.');
      setOpenmsg(true);
    }
  };
  const handletotal = (valor: string | undefined) => {
    if (valor != null) {
      const valorNumerico = parseFloat(valor.replace(',', '.'));
      const valorInicialNumerico = parseFloat(String(horimetroinicial).replace(',', '.'));
      if (!isNaN(valorNumerico) && !isNaN(valorInicialNumerico)) {
        const tvalor = valorNumerico - valorInicialNumerico;
        formRef.current?.setFieldValue('horastrabalhadas', tvalor.toFixed(2)); // Garantir duas casas decimais
      } else {
        console.error('Valores inválidos: ', valor, horimetroinicial);
      }
    }
  };


  return (
    <LayoutBaseDePagina
      titulo={id === 'novo' ? 'Novo Produto' : descricao}
      barraDeFerramentas={
        <FerramentasDeDetalhe
          textoBotaoNovo='Novo'
          mostrarBotaoSalvarEFechar
          mostrarBotaoSalvarCarregando={isLoading}
          mostrarBotaoSalvarEFecharCarregando={isLoading}
          mostrarBotaoNovo={id !== 'novo'}
          mostrarBotaoApagar={id !== 'novo'}
          mostrarBotaoApagarCarregando={isLoading}
          mostrarBotaoImpressao={false}
          aoClicarEmSalvar={save}
          aoClicarEmSalvarEFechar={saveAndClose}
          aoClicarEmVoltar={() => navigate('/abastecimento')}
          mostrarBotaoVoltarCarregando={isLoading}
          aoClicarEmApagar={() => handleDelete()}
          aoClicarEmNovo={() => navigate('/abastecimento/detalhe/novo')}
          mostrarBotaoNovoCarregando={isLoading}
        />
      }
    >
      <VForm ref={formRef} onSubmit={handleSave} placeholder="Seu Placeholder Aqui" onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
        <Snackbar anchorOrigin={{ vertical: 'top', horizontal: 'center' }} open={openmsg}  autoHideDuration={900} onClose={handleCloseMsg}>
          <Alert
            onClose={handleCloseMsg}
            severity={tms}
            variant="filled"
            sx={{ width: '100%' }}
          >
            {msg}
          </Alert>
        </Snackbar>
        <Snackbar open={openConfirm} anchorOrigin={{ vertical: 'top', horizontal: 'center' }}>
          <Alert
            severity="warning"  
            variant="filled"
            sx={{ display: 'flex', alignItems: 'center', width: '100%' }}
            action={
              <>
                <Button color="inherit" size="small" onClick={handleConfirmDelete}>
              Sim
                </Button>
                <Button color="inherit" size="small" onClick={handleCancelDelete}>
              Nâo
                </Button>
              </>
            }
          >
            Tem certeza que deseja excluir este registro?
          </Alert>
        </Snackbar>
        <Box margin={1} display="flex" flexDirection="column" component={Paper} variant="outlined">
          <Grid container direction="column" padding={2} spacing={2}>
            {isLoading && (
              <Grid item>
                <LinearProgress variant='indeterminate' />
              </Grid>
            )}
            <Grid container item direction="row" spacing={1}>
              <Grid item xs={12} sm={12} md={4} lg={4} xl={4}>
                <SwipeableTextMobileStepper
                  images={images}
                />
              </Grid>
              <Grid item xs={12} sm={12} md={8} lg={8} xl={8}>
                <Grid container item direction="row" spacing={1} >
                  <Grid item xs={12} sm={12} md={12} lg={9} xl={9}>
                    <AutoCompletePatrimonio
                      isExternalLoading={isLoading}
                    />
                  </Grid>
                  <Grid item xs={4} sm={4} md={3} lg={3} xl={3}>
                    <VTextFieldData
                      fullWidth
                      name='dataoperacao'
                      label='Data de Abastecimento'
                      disabled={isLoading}
                    />
                  </Grid>
                  <Grid item xs={6} sm={6} md={9} lg={9} xl={9}>
                    <VTextField
                      fullWidth
                      size='small'
                      name='operador'
                      label='Operador'
                      disabled={false}
                    />
                  </Grid>
                  <Grid item xs={6} sm={6} md={3} lg={3} xl={3}>
                    <AutoCompleteProduto2
                      Label='Tipo Combustível'
                      combustivel='true'
                      precoSaida={handleprecosaida}
                      idproduto={setidprod}
                    />
                  </Grid>
                  <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
                    <TextField
                      fullWidth
                      size="small"
                      value={horimetroinicial}
                      label="Horímetro/KM Inicial"
                      disabled={true}
                      onChange={() => { }}
                    />
                  </Grid>
                  <Grid item xs={4} sm={4} md={3} lg={3} xl={3}>
                    <VFieldMoney
                      fullWidth
                      size='small'
                      name='horimetro'
                      label='Horímetro/KM Atual'
                      calcular={handletotal}
                    />
                  </Grid>
                  <Grid item xs={4} sm={4} md={3} lg={3} xl={3}>
                    <VFieldMoney
                      fullWidth
                      size='small'
                      name='horastrabalhadas'
                      label='Horas Trabalhadas/ KM '
                      disabled={true}
                    />
                  </Grid>
                  <Grid item xs={4} sm={4} md={3} lg={3} xl={3}>
                    <VFieldMoney
                      fullWidth
                      size='small'
                      name='quantidade'
                      label='Quantidade'
                      calcular={handlepreco}
                    />
                  </Grid>
                  <Grid item xs={4} sm={4} md={3} lg={3} xl={3}>
                    <AutoCompletePivotfazenda />
                  </Grid>
                  <Grid item xs={4} sm={4} md={3} lg={3} xl={3}>
                    <AutoCompleteCultivo />
                  </Grid>
                  <Grid item xs={4} sm={4} md={6} lg={6} xl={6}>
                    <AutoCompleteAtividades
                    />
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Box>
      </VForm>
    </LayoutBaseDePagina>
  );
};